export default __webpack_public_path__ + "static/media/wrld.7020ad63.svg";